module.exports = __webpack_public_path__ + "img/double_chevron_right.544c2a44.svg";